export default __webpack_public_path__ + "static/media/promotion_qq.c8553768.svg";